import styled from 'styled-components';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import { breakPoint, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Popup = styled(DefaultPopup)`
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  display: block;
  padding: 0;
  width: 100vw;
  max-width: 656px;

  @media (${breakPoint(768)}) {
    max-width: 664px;
  }

  @media (${breakPoint(320)}) {
    max-width: 100%;
  }
`;

export const Header = styled.div`
    background: ${COLORS.lightRed};
    height: 143px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding-left: 53px;
    padding-right: 65px;
    width: 100%;

    @media(${breakPoint(768)}) {
        padding-left: 40px;
        padding-right: 60px;
    }

    @media(${breakPoint(320)}) {
        padding: 24px 16px 32px;
        display: block;
        height: auto;
    }
`;

export const LogoWrapper = styled.div`
    width: 152px;
    height: 113px;
    position: relative;
    flex-shrink: 0;
    margin-left: auto;
    display: block;

    @media(${breakPoint(1366)}) {
        width: 150px;
        height: 110px;
    }

    @media(${breakPoint(1024)}) {
        width: 140px;
        height: 108px;
    }

    @media(${breakPoint(768)}) {
        width: 148px;
        height: 114px;
    }

    @media(${breakPoint(320)}) {
        width: 138px;
        height: 113px;
        margin-left: 0;
        margin-bottom: 15px;
    }
`;

export const Logo = styled.img`
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media(${breakPoint(320)}) {
        left: 0;
        transform: translateY(-50%);
    }
`;

export const Name = styled.span`
    display: block;
    font: 400 16px/20px "Roboto", sans-serif;
    color: ${COLORS.white};

    @media(${breakPoint(320)}) {
        font-size: 12px;
        line-height: 18px;
    }
`;

export const HeaderTitle = styled.span`
    display: block;
    font: 400 24px/32px "Roboto", sans-serif;
    color: ${COLORS.white};

    @media(${breakPoint(320)}) {
        font-size: 20px;
        line-height: 28px;
    }
`;

export const HeaderContent = styled.div`
    margin-right: auto;
    display: block;
`;

export const Body = styled.div`
    background-color: ${COLORS.white};
    padding: 30px 55px 60px;
    width: 100%;

    @media(${breakPoint(768)}) {
        padding: 30px 40px 60px;
    }

    @media(${breakPoint(320)}) {
        padding: 30px 16px 60px;
    }
`;
